import React from "react";

import DonorCard from "../../DonorCard";
import DonationLevel, { calculatePromoTicketCount } from "../../DonationLevel";

const DonationCard = ({ donationLevel, donor,  promoCode }) => (
  <div>
    <DonationLevel
      donationLevel={donationLevel}
      promoTickets={calculatePromoTicketCount(donationLevel, promoCode)}
      selected
      emphasis
    />
    <DonorCard donor={donor} />
  </div>
);

export default DonationCard;
